import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmDialog({ open, onConfirm, onCancel }: ConfirmDialogProps): React.JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>האם אתה בטוח?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          פעולה זו תמחק את הקבוצה, את כל הקורסים בתוכה ואת כל הרכישות לקבוצה, זוהי פעולה הרסנית מאוד.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>ביטול</Button>
        <Button onClick={onConfirm} color="error" variant="contained">מחק - מסוכן</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog; 